var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',{staticClass:"masthead"},[_c('div',{staticClass:"h-100"},[_c('div',{staticClass:"row h-100 align-items-left"},[_c('div',{staticClass:"col-12 text-left"},[_c('h1',{staticClass:"font-weight-light",staticStyle:{"text-transform":"capitalize"}},[_vm._v("Welcome, "+_vm._s(_vm.getUserName()))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }